import { Email } from '@customTypes/Entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

export type EmailsState = {
  selected: Array<number>;
  query: string;
  names: { [key: number]: string };
};

const initialState: EmailsState = {
  selected: [],
  query: '',
  names: {},
};

export const emailsSlice = createSlice({
  name: 'emails',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<Email>) => {
      state.selected = state.selected.concat(action.payload.id);
      state.names[action.payload.id] = action.payload.name;
    },
    uncheck: (state, action: PayloadAction<number>) => {
      state.selected = state.selected.filter((s) => s !== action.payload);
      delete state.names[action.payload];
    },
    checkAll: (state, action: PayloadAction<Email[]>) => {
      state.selected = [];
      state.selected = state.selected.concat(action.payload.map((email) => email.id));
      action.payload.forEach((email) => (state.names[email.id] = email.name));
    },
    uncheckAll: (state) => {
      state.selected = [];
      state.names = {};
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
  },
});

export const { check, uncheck, checkAll, uncheckAll, setQuery } = emailsSlice.actions;

export const getSelectedEmails = (state: RootState) => state.emails.selected;

export const getSelectedNamedEmails = (state: RootState) =>
  Object.entries(state.emails.names).map(([k, v]) => ({
    id: Number(k),
    name: v,
  }));

export const getEmailsQuery = (state: RootState) => state.emails.query;

export default emailsSlice.reducer;
